import { render } from "./FindPw.vue?vue&type=template&id=3b863071"
import script from "./FindPw.vue?vue&type=script&lang=js"
export * from "./FindPw.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__